import { useContext } from "react";
import { userContext } from '../../contexts/userContext';
import CalendarWidget from "../schedule/CalendarWidget";
import { ProjectsWidget } from "../projects/ProjectsWidget";
import { useUserProjects } from "../../hooks/db"; // Import the function to get projects
import { Loader } from 'lucide-react';
import Unpaid from "../income/Unpaid";
import { Link } from "react-router-dom";

// Component: Dashboard
const Dashboard = () => {

    const user_id = useContext(userContext);
    const userProjects = useUserProjects(user_id[0]); // Use the custom hook
    // console.log("User Projects: ", userProjects);

    // Render the component
    return (
        <div id="dashboard" className="flex flex-col m-auto px-10 max-w-[1200px] self-center">
            <div id="dashboardTopRow" className="flex pt-3 pb-3 px-5 my-5 items-center gap-3">
                <span className="uppercase text-[9px] text-[#444] font-semibold tracking-[0.15em] mr-1">Quick Actions</span>
                <Link to="createproject" id="newProjectLink">
                    <button className="flex items-center gap-1.5 py-1.5 px-4 bg-[#ffee00] rounded-lg uppercase font-bold text-[11px] text-black tracking-widest transition-all duration-200 hover:bg-[#ffe000] hover:shadow-[0_4px_20px_rgba(255,238,0,0.2)] active:scale-95">
                        <span>+</span> New Project
                    </button>
                </Link>
            </div>
            <div id="dashboardBottomRow" className="flex flex-col justify-between gap-4 lg:flex-row">
                <div id="dashboardLeft" className="flex flex-col gap-4 items-center">
                    <div id="projectWidgetTray" className="gradientBG px-5 py-5 min-h-[250px] max-h-[600px] w-[350px]">
                        <ProjectsWidget projects={userProjects}/>
                    </div>
                </div>
                <div id="dashboardRight" className="flex flex-col gap-4 items-center">
                    {userProjects ? (
                        <CalendarWidget projects={userProjects}/>
                    ) : (
                        <div id="calendarWidget" className="gradientBG flex items-center justify-center w-[400px] h-[300px]">
                            <Loader className="spinning"/>
                        </div>
                    )}
                    <div className="gradientBG m-auto px-5 py-5 min-h-[250px] max-h-[600px] w-[400px]">
                        <Unpaid projects={userProjects}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;